import React, { useState } from "react";

import { commonAPI } from "api/commonAPI";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Imgs from "../../../assets/images/login.jpeg";
import { isEmpty } from "../../../util";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import { isAdmin, selectedMenu, subMenuState } from "../../../state";
import {
  fadeIn,
  fadeIn2,
  fadeIn3,
  fadeInS,
} from "../../../styled/StyledComponent";

const Sign = () => {
  const navigate = useNavigate();
  const [inputState, setInputState] = useState({
    email: "",
    password: "",
  });
  const [success, setSuccess] = useState(false);
  const setIsAdmin = useSetRecoilState(isAdmin);

  const isAdminState = useRecoilValue(isAdmin);
  const [selected, setSelected] = useRecoilState(selectedMenu);
  const [selectedSubMenu, setSelectedSubMenu] = useRecoilState(subMenuState);
  const onChange = (e) => {
    setInputState({
      ...inputState,
      [e.target.name]: e.target.value,
    });
  };
  const login = async () => {
    await commonAPI
      .postSignInData({
        data: {
          ...inputState,
        },
      })
      .then((res) => {
        console.log("res", res);
        if (!isEmpty(res?.data?.accessToken)) {
          setTimeout(() => {
            setSuccess(true);
            setTimeout(() => {
              window.sessionStorage.setItem(
                "accessToken",
                res?.data?.accessToken
              );
              window.sessionStorage.setItem(
                  "roleType",
                  res?.data?.roleType
              );
              if (!isAdminState) {
                setSelected("Classes");
                navigate("/main/classes");
              } else {
                setSelected("Classes");
                navigate("/main/classes");
                setSelectedSubMenu("In Progress");
              }
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }, 300);
          }, 300);
        }
      });
  };

  console.log("@success", success);
  const onKeydown = (e) => {
    if (e.keyCode === 13) {
      login();
    }
  };

  const signUp = () => {
    const step = 1;
    navigate(`/instructor_application/step${step}`);
  }

  return (
    <Container className={success ? "on" : ""}>
      <Content>
        <Inner>
          <Visual>
            <img src={Imgs} alt="" />
          </Visual>
          <Contents>
            <h1>Welcome to Whoflex Instructor Console</h1>
            <p>Please sign in to continue to your account.</p>
            <InputItem>
              <span>Email</span>
              <input
                name={"email"}
                value={inputState.email}
                onChange={onChange}
              />
            </InputItem>
            <InputItem>
              <span>Password</span>
              <input
                data-sign={"*"}
                className={"password"}
                value={inputState.password}
                name={"password"}
                type="password"
                onChange={onChange}
                onKeyDown={(e) => {
                  onKeydown(e);
                }}
              />
            </InputItem>
            <Login onClick={login}>
              <span>SIGN IN</span>
            </Login>
            <Pa>Forgot password?</Pa>
            <Divider></Divider>
            <Text onClick={signUp}>
              <p>
                Interested in becoming a Whoflex Instructor?
                <span>Apply here</span>
              </p>
            </Text>
          </Contents>
        </Inner>
      </Content>
    </Container>
  );
};
export default Sign;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 100px;
  opacity: 1;
  transition: all 0.2s;
  position: relative;

  @media screen and (max-width: 768px) {
    padding: 30px 30px !important;
    align-items: flex-start;
  }
  @media screen and (max-width: 550px) {
    padding: 10px 20px !important;
    align-items: flex-start;
    background: #fff;
    //padding-bottom: 30% !important;
  }
  &.on {
    transform-origin: center;
    transform: scale(1.3);
    opacity: 0;
  }
`;

const Content = styled.div`
  width: 100%;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  max-width: 1160px;
  max-height: 90vh;
  @media screen and (max-width: 1199px) {
    max-width: 550px !important;
  }
`;
const Inner = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;
const Visual = styled.div`
  width: 50%;
  height: auto;
  min-width: 50%;
  overflow: hidden;
  animation: ${fadeInS} 0.3s linear;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media screen and (max-width: 1199px) {
    display: none;
  }
`;
const Contents = styled.div`
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding: 66px 57px;

  @media screen and (min-width: 1200px) {
    width: 50% !important;
  }
  @media screen and (max-width: 576px) {
    padding: 66px 57px !important;
  }
  @media screen and (max-width: 550px) {
    padding: 30px 20px 0px 20px !important;
  }

  h1 {
    font-family: Arial, sans-serif;
    color: #000;
    font-size: 34px;
    line-height: 41px;
    margin-bottom: 10px;

    @media screen and (max-width: 768px) {
      font-size: 26px;
      font-weight: 400;
      line-height: 36px;
      margin-bottom: 13px;
      color: #000;
    }
  }
  p {
    font-size: 16px;
    color: #343434;
    line-height: 23px;
    font-family: Arial, sans-serif;
    margin-bottom: 27px;
  }
`;

const InputItem = styled.div`
  font-size: 15px;
  color: #000;
  display: flex;
  flex-direction: column;
  //margin-bottom: 35px;
  padding-bottom: 30px;
  span {
    display: flex;
    font-size: 15px;
    margin-bottom: 5px;
    font-family: Arial, sans-serif;
    line-height: 23px;
  }
  input {
    &.password {
      letter-spacing: 3px;
      font-size: 14px !important;
    }
    font-family: Arial, sans-serif;
    background: #fff;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    max-height: 40px !important;
    outline: none;
    font-size: 15px;
    padding: 0 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    outline: 0;
    &:focus {
      border: solid 1px #ddc260ba;
    }
  }
`;

const Login = styled.div`
  font-size: 16px;
  color: #fff;
  height: 52px;
  background: #ddc260;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 13px;
  cursor: pointer;
  &:hover {
    background: #000;
  }
  transition: all 0.3s;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    width: 100%;
    height: 100%;
  }
`;

const Pa = styled.p`
  text-align: right;
  cursor: pointer;
  color: #e0c363 !important;
  text-decoration: none;
  font-weight: 700;
  font-size: 14px !important;
  line-height: 23px !important;
  margin-bottom: 30px !important;
`;

const Text = styled.div`
  display: flex;
  cursor: pointer;
  p {
    font-size: 14px !important;
    line-height: 23px !important;
  }
  span {
    font-family: Arial, sans-serif;
    margin-left: 6px;
    color: #e0c363;
    text-decoration: none;
    font-weight: 700;
    font-size: 14px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #33333340;
  margin-bottom: 36px;
  @media screen and (max-width: 768px) {
    margin-bottom: 10px;
  }
`;
